import { Component } from "react";

// markup
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";

export default class TableCellApplicationActions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  handleOpen = () => {
    this.props.getAccountInfoForId(this.props.item.AccountId);
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleReject = () => {
    this.props.rejectApplication(this.props.item.Id);
    this.handleClose();
  };

  render() {
    let noActionText = "No action Available";
    let isEmptyGuid =
      this.props.item.DirectDebitAccountId ===
      "00000000-0000-0000-0000-000000000000";

    let stateAwaitingReview =
      this.props.item.Stage === "AwaitingCompletion" ||
      this.props.item.Stage === "AwaitingManualReview" ||
      this.props.item.Stage === "OnHold";

    let alreadyHandled =
      this.props.item.Stage === "ManuallyApproved" ||
      this.props.item.Stage === "ManuallyRejected";

    if (!stateAwaitingReview)
      noActionText = "Cannot approve application in this stage";
    else if (isEmptyGuid)
      noActionText = "User did not select direct debit account";
    const actions = [
      <Button
        key="1"
        variant="outlined"
        keyboardFocused={false}
        onClick={this.handleReject}
      >
        Reject
      </Button>,
      <Button
        key="2"
        variant="outlined"
        keyboardFocused={false}
        onClick={this.handleClose}
      >
        Cancel
      </Button>,
    ];

    return !alreadyHandled ? (
      <div className="table-cell-actions">
        <Button
          variant="contained"
          color="primary"
          onClick={this.handleOpen}
          style={{ marginRight: "2px" }}
        >
          Reject
        </Button>
        <Dialog
          title="Reject application"
          modal={false}
          open={this.state.open}
          onClose={this.handleClose}
        >
          <DialogContent>
            Reject application id: {this.props.item.Id}
          </DialogContent>
          <DialogActions>{actions}</DialogActions>
        </Dialog>
      </div>
    ) : (
      <div className="table-cell-actions">{noActionText}</div>
    );
  }
}
